export default __webpack_public_path__ + "static/media/pdficon.91b43b37.svg";